import { authHeaders } from "../../../mainApiRoutes/nonce";

export const CURRENT_URL = `${window.location.protocol}//${window.location.host}`;
export const API_URL = `${CURRENT_URL}/wp-json/tmt-insurance/v1`;

const eventLogsUrl = `${API_URL}/event`;
const getEventLogsUrl = `${eventLogsUrl}/logs`;

export const getEventLogs = async (userId) => {
  const url = userId ? `${getEventLogsUrl}?user_id=${userId}` : getEventLogsUrl;
  const response = await fetch(url, { headers: authHeaders() });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  const json = await response.json();
  return json;
};
